import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsSiemensComponent } from './simple-icons-siemens.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsSiemensComponent ],
    exports:      [ SimpleIconsSiemensComponent ],
    bootstrap:    []
})
export class SimpleIconsSiemensModule {}
